import { Box, Button, Grid, Paper, Typography } from '@mui/material';
import { useSnackbar } from 'notistack';
import { useNavigate } from 'react-router-dom';
import configSiteUrls from '../../../configs/configSiteUrls';

export const OuvidoriaMenu = () => {
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();

  const handleNovaSolicitacao = () => {
    navigate(configSiteUrls.SITE_OUVIDORIA_PUBLIC_CREATE);
  };

  const handleMinhasSolicitacoes = () => {
    navigate(configSiteUrls.SITE_OUVIDORIA_PUBLIC_CONSULT);
  };

  const handlePerguntasFrequentes = () => {
    console.log('Perguntas frequentes clicado');
    // navigate('/ouvidoria/faq');
  };

  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        mt: 4,
        mb: 4
      }}
    >
      <Paper
        elevation={3}
        sx={{
          width: { xs: '95%', sm: '80%', md: '70%' },
          maxWidth: '800px',
          p: 3,
          textAlign: 'center',
          mx: 'auto',
          mt: 4,
          mb: 4,
          bgcolor: '#ffff', // fundo cinza claro
          borderRadius: 2
        }}
      >
        {/* Banner compacto */}
        <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center', mb: 3 }}>
          <Box
            component="img"
            src="/images/ouvidoria/BannerOuvidoria.png"
            alt="Banner Ouvidoria"
            sx={{
              width: { xs: '70%', sm: '50%', md: '40%' },
              maxWidth: '250px',
              borderRadius: 1
            }}
          />
        </Box>

        {/* Título */}
        <Typography
          variant="h6"
          sx={{
            mb: 4,
            fontWeight: 500,
            fontSize: { xs: '16px', sm: '18px', md: '20px' }
          }}
        ></Typography>

        {/* Botões do menu */}
        <Grid container spacing={2} justifyContent="center">
          <Grid item xs={12} sm={6} md={4}>
            <Button fullWidth variant="contained" color="primary" onClick={handleNovaSolicitacao}>
              Nova Solicitação
            </Button>
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <Button fullWidth variant="outlined" color="primary" onClick={handleMinhasSolicitacoes}>
              Consultar Solicitação
            </Button>
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <Button fullWidth variant="text" color="primary" onClick={handlePerguntasFrequentes}>
              Perguntas Frequentes
            </Button>
          </Grid>
        </Grid>
      </Paper>
    </Box>
  );
};
export default OuvidoriaMenu;
